/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

// Re-exported from lib so the api layer can share program matching without violating dependency direction.
export { programForVin, resolveProgramForVin } from '@/lib/programMatch';

/** Last launched VIN, cached client-side for the continue panel. */
export interface LastOpened {
  vin: string;
  system?: string;
  programId?: number;
  program?: string;
  make?: string;
  model?: string;
  year?: string;
  openDtcCodes: string[];
}

const LAST_OPENED_KEY = 'ediag.lastOpened';

export function setLastOpened(value: LastOpened): void {
  try {
    localStorage.setItem(LAST_OPENED_KEY, JSON.stringify(value));
  } catch {
    /* storage unavailable (private mode / quota) - non-fatal */
  }
}

export function getLastOpened(): LastOpened | null {
  try {
    const raw = localStorage.getItem(LAST_OPENED_KEY);
    return raw ? (JSON.parse(raw) as LastOpened) : null;
  } catch {
    return null;
  }
}
